import FeatureLinking from "components/feature-entity-linking-page";
import { FeatureTypes } from "entity-app/constants";
import { useLocation } from "react-router-dom";

function FeatureSubmittalLinking() {
  const { state } = useLocation() as { state: any };
  return (
    <FeatureLinking
      featureTypeId={FeatureTypes.SUBMITTALS}
      leftTabEntityTypes={[FeatureTypes.MATERIALS, FeatureTypes.ACTIVITIES]}
      state={state}
    />
  );
}

export default FeatureSubmittalLinking;
